<!--Tabla-->
<div class="w-full flex flex-col md:flex-row">
    <table  class="w-full rounded-sm">
        <tbody>
            <tr class="border py-0 ml-2 text-xs md:text-sm  bg-gray-200">
                <td class="w-5/12 md:w-5/12 font-semibold"> 
                Título: </td>
                <td class="w-4/12 md:7/12 text-xs md:text-sm"> {{ficha.titulo}}</td>
            </tr>
            <tr class="border py-0 ml-2 text-xs md:text-sm">
                <td class="w-5/12 md:w-5/12 font-semibold">No. de Registro: </td>
                <td class="w-7/12 md:7/12 text-xs md:text-sm"> {{ficha.noRegistro}}</td>
            </tr>
            <tr class="border py-0 ml-2 text-xs md:text-sm">
                <td class="w-5/12 md:w-5/12 font-semibold">Propietario: </td>
                <td class="w-7/12 md:7/12 text-xs md:text-sm">{{ficha.propietario}}</td>
            </tr>
            <tr class="border py-0 ml-2 text-xs md:text-sm">
                <td class="w-5/12 md:w-5/12 font-semibold">Poseedor: </td>
                <td class="w-7/12 md:7/12 text-xs md:text-sm">{{ficha.poseedor}}</td>
            </tr>
            <tr class="border py-0 ml-2 text-xs md:text-sm">
                <td class="w-5/12 md:w-5/12 font-semibold">Tipo de Poseedor: </td>
                <td class="w-7/12 md:7/12 text-xs md:text-sm">
                    <mat-select
                        *ngIf="detalle?.tipoPoseedor && tipoPoseedor?.length > 0"
                        class="flex-1 text-xs md:text-sm pr-2"
                        [(ngModel)]="detalle.tipoPoseedor" 
                        id="tipoPoseedor" 
                        (selectionChange)="putDetalleBienCultural()">
                        <mat-option [value]="ninguna">Ninguno</mat-option>
                        @for (tipo of tipoPoseedor; track tipo) {
                        <mat-option [value]="tipo">
                            {{tipo.descripcion}}
                        </mat-option>
                        }
                    </mat-select>
                </td>
            </tr>
            <tr class="border py-0 ml-2 text-xs md:text-sm">
                <td class="w-5/12 md:w-5/12 font-semibold">Propiedad: </td>
                <td class="w-7/12 md:7/12 text-xs md:text-sm"> 
                    <mat-select
                        *ngIf="detalle?.tipoPropiedad && tipoPropiedad?.length > 0"
                        class="flex-1 text-xs md:text-sm pr-2"
                        [(ngModel)]="detalle.tipoPropiedad" 
                        id="tipoPropiedad" 
                        (selectionChange)="putDetalleBienCultural()">
                        
                        @for (tipo of tipoPropiedad; track tipo) {
                        <mat-option [value]="tipo">
                            {{tipo.descripcion}}
                        </mat-option>
                        }
                    </mat-select>
                </td>
            </tr>
            
            <tr class="border py-0 ml-2 text-xs md:text-sm">
                <td class="w-5/12 md:w-5/12 font-semibold">Dirección: </td>
                <td class="w-7/12 md:7/12 text-xs md:text-sm">{{ficha.direccion}}</td>
            </tr>
            <tr class="border py-0 ml-2 text-xs md:text-sm">
                <td class="w-5/12 md:w-5/12 font-semibold">Departamento: </td>
                <td class="w-7/12 md:7/12 text-xs md:text-sm">{{ficha.departamento.descripcion}}</td>
            </tr>
            <tr class="border py-0 ml-2 text-xs md:text-sm">
                <td class="w-5/12 md:w-5/12 font-semibold">Municipio: </td>
                <td class="w-7/12 md:7/12 text-xs md:text-sm">{{ficha.municipio.descripcion}}</td>
            </tr>
        </tbody>
    </table>
</div>
        